import { render, staticRenderFns } from "./NewShopNoWebhookBot.vue?vue&type=template&id=fe8c3d56&scoped=true&"
import script from "./NewShopNoWebhookBot.vue?vue&type=script&lang=js&"
export * from "./NewShopNoWebhookBot.vue?vue&type=script&lang=js&"
import style0 from "./NewShopNoWebhookBot.vue?vue&type=style&index=0&id=fe8c3d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8c3d56",
  null
  
)

export default component.exports